"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_options_core_1 = require("owa-options-core");
var store_1 = require("../store/store");
var owa_calendar_configuration_1 = require("owa-calendar-configuration");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    calendarConfiguration: function () { return owa_calendar_configuration_1.getCalendarConfiguration(); },
})(function isAppearanceOptionDirty(state) {
    if (!state.calendarConfiguration) {
        return false;
    }
    var weekStartDay = owa_options_core_1.getFallbackValueIfNull(state.optionState.weekStartDay, state.calendarConfiguration.WeekStartDay);
    return weekStartDay !== state.calendarConfiguration.WeekStartDay;
});
//# sourceMappingURL=isAppearanceOptionDirty.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/calendar/owa-calendar-appearance-option/lib/utils/isAppearanceOptionDirty.js
// module id = 5264
// module chunks = 2